// import React from "react";
// import "./ceo_details.css";
// import pr2 from "../../img/Designer (8) 1.png";
// import coreImg from "../../img/Frame 1592.png";
// import pr3 from "../../img/Feature 2.png";
// import pr4 from "../../img/Feature 3.png";
// // import pr4 from "../../img/wikiworks logo 230725-01 2.png";

// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/pagination";
// import "swiper/css/navigation";
// import "../tie_ups/tie_ups.css";

// function CeoDetails() {
//   return (
//     <div className="whoWeAreMain-ceo">
//       <div className="tie-up-header" style={{ marginTop: "1rem" }}>
//         <div className="norm-tie-up-text">Meet Our </div>
//         <div className="hori-space"></div>
//         <div className="color-tie-up-text-col">Leaders</div>
//         {/* <div className="hori-space"></div>
//           <div className="norm-tie-up-text">brands and agencies</div> */}
//       </div>
//       <div className="ceo-cards-wrap-ceo">
//         <div className="ceo-indi-card-ceo">
//           <div className="card-ceo">
//             <div className="card-image-ceo"></div>
//             <div className="card-content-ceo">
//               <p className="author-ceo">Santhi Chittem</p>

//               <p className="quote-ceo">
//                 “Santhi Chittem brings a rare blend of entrepreneurial spirit,
//                 financial acumen, and creative insight to her role as Director
//                 at Wikiworks. After successfully launching her own digital
//                 venture on YouTube, she joined the company with a clear purpose:
//                 to streamline financial operations, elevate employee engagement,
//                 and foster a culture rooted in empathy and growth. Her
//                 leadership is defined by a deep belief that a company’s success
//                 is inseparable from the success of its people. At Wikiworks, she
//                 plays a key role in shaping a workplace where innovation and
//                 care go hand in hand, empowering every team member to thrive as
//                 the company evolves.”
//               </p>
//               {/* <p className="position-ceo">Chairman, Wikiworks</p> */}
//             </div>
//           </div>
//         </div>
//         <div className="divider-ceo"></div>
//         <div className="ceo-indi-card-ceo">
//           <div className="card-ceo">
//             <div className="card-image-ceo-2"></div>
//             <div className="card-content-ceo">
//               <p className="author-ceo">Hanuman Chittem</p>

//               <p className="quote-ceo">
//                 “Hanuman Chittem is a global digital transformation leader with
//                 over 25 years of experience driving innovation in SAP, HR Tech,
//                 and customer experience. As CEO of Wikiworks, he brings a deep
//                 commitment to building intelligent systems that protect,
//                 empower, and build trust across the workforce. Recognized for
//                 his ability to turn complex challenges into scalable,
//                 human-first solutions, Hanuman is a sought-after strategist
//                 trusted by top enterprises around the world. Rooted in a career
//                 of leading large-scale change, his mission at Wikiworks is to
//                 help companies support their people, especially the
//                 often-unheard contract workforce, through technology that
//                 delivers real safety, assurance, and dignity”
//               </p>
//               {/* <p className="position-ceo">CEO, Wikiworks</p> */}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default CeoDetails;
import React, { useState, useEffect } from "react";
import "./ceo_details.css";
import { useSpring, animated, config } from "@react-spring/web";
import { useInView } from "react-intersection-observer";

function CeoDetails() {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: isMounted && window.innerWidth < 768 ? 0.1 : 0.3,
    rootMargin: '0px 0px -100px 0px'
  });

  // Common animation configuration
  const getAnimationProps = (delay = 0) => ({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0)' : 'translateY(30px)',
    config: config.gentle,
    delay: inView ? delay : 0
  });

  const headerProps = useSpring(getAnimationProps(100));
  const cardProps = useSpring(getAnimationProps(300));

  const ceoData = [
    {
      id: 1,
      imageClass: "card-image-ceo-2",
      name: "Hanuman Chittem",
      title: "Chief Executive Officer",
      quote: "Hanuman Chittem is a global digital transformation leader with over 25 years of experience driving innovation in SAP, HR Tech, and customer experience. As CEO of Wikiworks, he brings a deep commitment to building intelligent systems that protect, empower, and build trust across the workforce."
    },
    {
      id: 2,
      imageClass: "card-image-ceo",
      name: "Santhi Chittem",
      title: "Director",
      quote: "Santhi Chittem brings a rare blend of entrepreneurial spirit, financial acumen, and creative insight to her role as Director at Wikiworks. After successfully launching her own digital venture on YouTube, she joined the company with a clear purpose."
    },

    {
      id: 4,
      imageClass: "card-image-ceo-4",
      name: "Gopal Amin",
      title: "Chairman of the Board",
      quote: "Chairman of the Board A visionary leader and entrepreneur with over three decades of experience, Gopal Amin has successfully driven growth and transformation for multiple companies."
    }
  ];

  if (!isMounted) {
    return <div className="whoWeAreMain-ceo" />; // Return empty div during SSR
  }

  return (
    <div className="whoWeAreMain-ceo" ref={ref}>
      <animated.div className="tie-up-header" style={headerProps}>
        <div className="norm-tie-up-text">Meet Our </div>
        <div className="hori-space"></div>
        <div className="color-tie-up-text-col">Leaders</div>
      </animated.div>
      
      <div className="ceo-cards-wrap-ceo">
        {ceoData.map((ceo, index) => (
          <React.Fragment key={ceo.id}>
            {index > 0 && <div className="divider-ceo" />}
            <animated.div 
              className="ceo-indi-card-ceo" 
              style={cardProps}
            >
              <div className="card-ceo">
                <div className={ceo.imageClass}></div>
                <div className="card-content-ceo">
                  <p className="author-ceo">{ceo.name}</p>
                  {ceo.title && <p className="author-ceo2">{ceo.title}</p>}
                  <p className="quote-ceo">"{ceo.quote}"</p>
                </div>
              </div>
            </animated.div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

export default CeoDetails;